export const LISTBOX_ID = 'searchbar-dropdown-listbox';